import React  , {useState} from "react";
import { Typography } from '@mui/material';
/**
 * This is a React component called H4 that renders a Typography element with customizable font style,
 * color, and title.
 * @returns a Typography component with the following props and styles:
 */
export default function H4 (props){
    const [fontStyle, setFontStyle] = useState(props.fontStyle ? props.fontStyle : "Regular");
    const [color, setColor] = useState(props.color ? props.color : "black");
    const [fontWeight, setFontWeight] = useState(props.fontWeight ? props.fontWeight : "900");
    return (
        <Typography sx={{
            color: {color},
          
            textAlign: "left",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "DM Sans",
            fontSize: "18px",
            fontStyle: {fontStyle},
            fontWeight: {fontWeight},
            lineHeight: "16px", 
            weight : "24px",
            height : "20px",
            textTransform: "none",
        }} >
            {props.title}
            </Typography>
    )
}